import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Button } from '@material-ui/core';

import { Dialog } from '~/components';
import { t } from '~/helpers';
import { storeData } from '~/store/modules/cercasVirtuais/actions';

import Maps, { loadGoogleMapsApi } from '../Maps';

export default function TopBar() {
  const [open, setOpen] = useState(false);
  const [mapVisible, setMapVisible] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    loadGoogleMapsApi().catch(() => {});
  }, []);

  /**
   * create fence
   *
   * @param {Object} params
   */
  const handleSubmit = useCallback((params) => {
    dispatch(storeData(params));
  });

  const handleOpen = useCallback(() => {
    setMapVisible(false);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setMapVisible(false);
    setOpen(false);
  }, []);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleOpen}
      >
        {t('s.geral.botaoincluir')}
      </Button>

      <Dialog
        open={open}
        toggle={handleClose}
        title={t('s.menu.configuracao.cercavirtual')}
        onEntered={() => setMapVisible(true)}
        onExited={() => setMapVisible(false)}
      >
        <Maps callback={(value) => handleSubmit(value)} visible={mapVisible} />
      </Dialog>
    </>
  );
}
